import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ShareMenu2 from "../../components/ShareMenu2";
import AddToList from "../../components/AddToList";
import AddOrRemoveLike from "../../Products/AddOrRemoveLike";
import { Card, Spinner } from "react-bootstrap";
import "./style.css";
import { UserAuth } from "../../Context";
import AddOrRemoveFavourites from "../../Products/AddOrRemoveFavourites";
import BrandDisplay from "../../NewsFeed/BrandDisplay";
import formatPrice from "../../lib/formatPrice";
import { getBrandDetails } from "../../lib/getBrandDetails";
import useFetch from "../../hooks/useFetch";
import ProductCardExpanded from "./ProductCardExpanded";
import AddToChat from "../../components/AddToChat";
import AddToCart from "../../components/AddToCart";

const TestProductCard4 = ({ product, isStrip, handleClick, isExpanded }) => {
  const [likeCount, setLikeCount] = useState(product?.likes);
  const [brandData, setBrandData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showCard, setShowCard] = useState(true);
  const { user } = UserAuth();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const { data: activeBrands } = useFetch(
    `${process.env.REACT_APP_API}/api/activeBrands`
  );
  const [badgeText, setBadgeText] = useState(null);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Determine which badge to show (if any)
    const now = new Date();
    const lastUpdate = product.dateLastUpdate ? new Date(product.dateLastUpdate) : null;
    const isRecent = lastUpdate && (now - lastUpdate) <= (7 * 24 * 60 * 60 * 1000);

    if (isRecent) {
      if (product.oldPrice > 0) {
        setBadgeText("Price Drop");
      } else {
        setBadgeText("Recently Added");
      }
    } else {
      setBadgeText(null);
    }
  }, [product.dateLastUpdate, product.oldPrice]);

  const fetchBrandData = async () => {
    try {
      const result = await getBrandDetails(product?.supplier, activeBrands);
      setBrandData(result);
    } catch (error) {
      console.error("Error getting brand data:", error);
    }
  };

  useEffect(() => {
    if (!product || !activeBrands) return;
    fetchBrandData();
  }, [product, activeBrands]);

  const handleImageLoad = () => {
    setLoading(false);
  };

  // If expanded, render the expanded view
  if (isExpanded) {
    return (
      <ProductCardExpanded
        product={product}
        brandData={brandData}
        handleClick={handleClick}
        user={user}
        setLikeCount={setLikeCount}
      />
    );
  }

  return (
    <div className={`shadow-sm p-2 rounded-2 bg-mode m-1 ${isExpanded ? "expanded-card" : ""}`}>
      <Card onClick={handleClick} className="position-relative">
        <div className={`d-flex ${isExpanded ? "flex-row" : "flex-column"}`}>
          <div
            style={{
              position: "relative",
              width: isExpanded ? "123px" : "auto",
              overflow: "hidden",
            }}
          >
            {loading && (
              <div
                className="skeleton"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  height: "100%",
                  backgroundColor: "#eef0f2",
                }}
              ></div>
            )}
            <Card.Img
              src={product?.imageUrl}
              className="rounded-2"
              style={{
                opacity: loading ? 0 : 1,
                transition: "opacity 0.5s ease-in-out",
                objectFit: "cover",
                height: "auto",
                display: "inline",
              }}
              onLoad={handleImageLoad}
              onError={() => setShowCard(false)}
              loading="lazy"
            />

            {/* Price badge */}
            <div
              style={{
                position: "absolute",
                backgroundColor: "#59A800",
                color: "white",
                width: "4rem",
                fontSize: "10px",
                alignContent: "center",
                height: "1.5rem",
              }}
              className="rounded-pill text-center top-0 end-0 m-1"
            >
              PKR{" "}
              {product?.newPrice
                ? formatPrice(product.newPrice)
                : formatPrice(product.oldPrice)}
            </div>
            {badgeText === "Price Drop" && <div className="rounded-pill text-center bottom-0 start-0 m-1" style={{
              position: "absolute",
              // backgroundColor: "#59A800",
              color: "white",
              width: "4rem",
              fontSize: "12px",
              alignContent: "center",
              height: "1.5rem",
            }}>
              <span className="badge bg-danger text-white">
                {product?.discount}% OFF
              </span>
            </div>}
            {/* New/Price Drop badge */}
            {/* {badgeText && (
              <div
                style={{
                  position: "absolute",
                  backgroundColor: badgeText === "Price Drop" ? "#FF0000" : "#59A800",
                  color: "white",
                  width: "5rem",
                  fontSize: "10px",
                  alignContent: "center",
                  height: "1.5rem",
                }}
                className="rounded-pill text-center top-0 start-0 m-1"
              >
                {badgeText}
              </div>
            )} */}
          </div>
        </div>
      </Card>

      {isSmallScreen ? (
        <div className={`d-flex flex-column`}>
          <div className="d-flex align-items-center">
            {/* Logo */}
            <div
              className="avatar me-2"
              style={{
                width: "30px",
                height: "30px",
              }}
            >
              <Link to={"/BrandHome/" + product?.supplier}>
                <img
                  className="avatar-img rounded border"
                  src={brandData?.logoUrl}
                  alt=""
                />
              </Link>
            </div>
            <div
              className="d-flex flex-column justify-content-start mb-2"
              style={{ width: "78%" }}
            >
              <div className="mb-0">
                <BrandDisplay brandData={brandData} type={"ProductCard"} />
              </div>
              <div
                className="h6 text-body position-relative text-truncate mb-0"
                style={{
                  marginTop: "2px",
                  fontSize: "11px",
                  width: "92%",
                }}
              >
                {badgeText ? (
                  <span
                    style={{
                      backgroundColor: badgeText === "Price Drop" ? "#FF0000" : "#59A800",
                      color: "white",
                      padding: "2px 6px",
                      borderRadius: "10px",
                      fontSize: "10px"
                    }}
                  >
                    {badgeText}
                  </span>
                ) : (
                  product?.name
                )}
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <AddToChat product={product} componentName={"Discover"} />
            </div>
            <div className={`d-flex`} style={{ gap: "0.4rem" }}>
              <div
                style={{ width: "1.3rem", height: "1.3rem" }}
                className="icon-xs text-white rounded-circle border border-secondary"
              >
                <AddToList product={product} componentName={"strip2"} />
              </div>
              <div
                style={{ width: "1.3rem", height: "1.3rem" }}
                className="icon-xs text-white rounded-circle border border-secondary"
              >
                <AddOrRemoveLike
                  user={user}
                  product={product}
                  setLikeCount={setLikeCount}
                  componentName={"strip2"}
                />
              </div>
              <div
                style={{ width: "1.3rem", height: "1.3rem" }}
                className="icon-xs text-white rounded-circle border border-secondary"
              >
                <AddToCart
                  user={user}
                  product={product}
                  componentName={"ShopListProdCard"}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={`d-flex flex-column mt-1`}>
          <div className="d-flex align-items-center">
            {/* Logo */}
            <div
              className="avatar me-2"
              style={{
                width: "40px",
                height: "40px",
              }}
            >
              <Link to={"/BrandHome/" + product?.supplier}>
                <img
                  className="avatar-img rounded border"
                  src={brandData?.logoUrl}
                  alt=""
                />
              </Link>
            </div>
            <div
              className="d-flex flex-column justify-content-start mb-3"
              style={{ width: "78%" }}
            >
              <div className="mb-0">
                <BrandDisplay brandData={brandData} type={"ProductCard"} />
              </div>
              <div
                className="h6 position-relative text-truncate mb-0"
                style={{
                  marginTop: "2px",
                  fontSize: "13px",
                  width: "100%",
                }}
              >
                {badgeText ? (
                  <span
                    style={{
                      backgroundColor: badgeText === "Price Drop" ? "#FF0000" : "#59A800",
                      color: "white",
                      padding: "4px",
                      borderRadius: "8px",
                      fontSize: "10px",
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      maxWidth: '7rem'
                    }}
                  >
                    {badgeText}
                  </span>
                ) : (
                  product?.name
                )}
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <AddToChat product={product} componentName={"Discover"} />
            </div>
            <div className={`d-flex gap-2`}>
              <div className="icon-xs text-white rounded-circle border border-secondary">
                <AddToList product={product} componentName={"strip2"} />
              </div>
              <div className="icon-xs text-white rounded-circle border border-secondary">
                <AddOrRemoveLike
                  user={user}
                  product={product}
                  setLikeCount={setLikeCount}
                  componentName={"strip2"}
                />
              </div>
              <div className="icon-xs text-white rounded-circle border border-secondary">
                <AddToCart
                  user={user}
                  product={product}
                  componentName={"ShopListProdCard"}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TestProductCard4;